<template>
  <div class="tab-content">
    <el-table :data="eq_data" :header-cell-style="{ color: 'black' }" v-loading="show_loading">
      <!-- 序号 -->
      <el-table-column type="index" label="序号" align="center" width="60">
      </el-table-column>

      <!-- 问题分类 -->
      <el-table-column prop="eq_class" label="问题分类" align="center" width="180">
      </el-table-column>

      <!-- 问题描述 -->
      <el-table-column  prop="eq_detail" label="问题描述" align="center"  :min-width="280"  :max-width="600" >
        <template #default="scope">
          <div class="eq-data">
            {{ scope.row.eq_detail }}
          </div>
        </template>
      </el-table-column>

      <!-- 我司建议 -->
      <el-table-column prop="suggestion" label="我司建议" align="center" width="400">
        <template #default="scope">
          <div class="eq-data">
            {{ scope.row.suggestion }}
          </div>
        </template>
      </el-table-column>

      <!-- 隐藏的附件上传 -->
      <el-table-column label="附件" align="center" width="180">
        <template #default="scope">
          <el-upload
              :ref="'uploadRef_' + scope.$index"
              class="upload-demo"
              :auto-upload="false"
              :on-change="handleFileChange(scope.row, scope.$index)"
              multiple
          >
          </el-upload>
        </template>
      </el-table-column>

      <!-- 操作：选择文件和删除 -->
      <el-table-column label="操作" align="center" width="180" v-if="!historyMode">
        <template #default="scope">
          <div class="action-buttons">
            <!-- 上传附件 -->
            <el-button size="small" @click="triggerUpload(scope.$index)">上传附件</el-button>
            <!-- 删除整行 -->
            <el-button size="small" type="danger" @click="deleteCheck(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>

  <div class="button-container">
    <el-button @click="" v-if="!historyMode">编辑</el-button>
    <el-button @click="" >导出</el-button>
    <el-button @click="save_check_list_and_eq" v-if="!historyMode">归档</el-button>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {postDetailData} from "@/api/result_history";

import {generateEQ} from "@/api/eq";

export default {
  emits: ['switch-tab'],
  data() {
    return {
      descriptionColumnWidth: 300,
      eq_data: [],
      historyMode: false,
      show_loading: false
    };
  },
  computed: {
    ...mapState(["eq", "startEq"]),
  },
  methods: {
    // 触发隐藏的按钮来选择文件
    triggerUpload(index) {
      const uploadRef = this.$refs['uploadRef_' + index];
      if (uploadRef) {
        const inputElement = uploadRef.$el.querySelector('input[type="file"]');
        if (inputElement) {
          inputElement.click(); // 手动触发文件选择框
        } else {
          console.error('File input element not found.');
        }
      } else {
        console.error('uploadRef is undefined for index', index);
      }
    },

    handleFileChange(row, index) {
      return (file) => {
        // 将文件存入当前行的 attachments 中
        // row.attachments.push(file);
        // // 自动上传
        // // this.$refs['uploadRef_' + index].submit();
        //
        // console.log("row", row);
      };
    },

    // 删除整行
    deleteCheck(row) {
      this.eq_data = this.eq_data.filter(item => item !== row);
    },

    async save_check_list_and_eq() {
      const detailData = JSON.stringify({
        "fileDescribeObjList": this.$store.state.fileDescribeObjList,
      })

      const eqData = JSON.stringify(this.eq_data)

      const id_and_time = Math.floor((new Date().getTime())/1000)
      const reqData = {
        id: id_and_time,
        create_time: id_and_time,
        user: 'Yahaha',
        file_path: this.$store.state.filePath,
        data: detailData,
        eq: eqData
      }
      const res = await postDetailData(reqData)

      this.$router.push({
        name: 'home'
      })
    },

    runHistoryMode(){
      this.eq_data = this.$store.state.eq
    },
    calculateColumnWidth() {
      const totalWidth = document.querySelector('.tab-content').clientWidth;
      const remainingSpace = totalWidth - 600; // Adjust based on other column widths
      return Math.max(400, remainingSpace); // Ensure a minimum width of 400px
    }
  },

  watch: {
    eq(newValue){
      if (this.historyMode) {
        this.runHistoryMode()
      }
    },

    async startEq(newValue) {

      const checkListToReq = []

      if (newValue) {
        const checkList = this.$store.state.checkList;
        let globalIndex = 0

        checkList.map(checkClassList => {
          checkClassList.check_obj.map(item => {
            item['eq_index'] = globalIndex

            checkListToReq.push({
              "index": globalIndex,
              "keyWord": item.keyword,
              "value": item.manual? item.manual:item.value,
              "reference_range": item.standard_value,
            })

            globalIndex++
          })
        })
        this.show_loading = true
        const res = await generateEQ(checkListToReq)
        this.show_loading = false

        this.eq_data = res
        this.$store.commit('setStartEq', false);
      }
    }
  },

  mounted() {
    this.historyMode = this.$route.query.history;
    if (this.historyMode) {

    }
  }
};
</script>

<style>
.el-upload {
  display: block !important;
}
</style>

<style scoped>
.eq-data {

}
</style>